import React from "react";

export default function Developerlogo() {
  return (
    <div className="dev_clients_logo_area">
      <div className="container">
        <div className="clients_intrigration">
          <a href=".#" className="c_items">
            <img src={require("../../image/csharp.png")} alt="" />
          </a>
          <a href=".#" className="c_items">
            <img src={require("../../image/dotnetcore-logo.png")} alt="" />
          </a>
       
          <a href=".#" className="c_items">
            <img src={require("../../image/postgress.png")} alt="" />
          </a>
      
    
       
          <a href=".#" className="c_items">
            <img src={require("../../image/sql-server.png")} alt="" />
          </a>
          <a href=".#" className="c_items">
            <img src={require("../../image/mongo.png")} alt="" />
          </a>
       
          <a href=".#" className="c_items">
            <img src={require("../../image/react.png")} alt="" />
          </a>
          <a href=".#" className="c_items">
            <img src={require("../../image/angular.png")} alt="" />
          </a>
          <a href=".#" className="c_items middle">
            <img src={require("../../image/javascript.png")} alt="" />
          </a>
          <a href=".#" className="c_items">
            <img src={require("../../image/html.png")} alt="" />
          </a>
       
          <a href=".#" className="c_items">
            <img src={require("../../image/css_logo.png")} alt="" />
          </a>
          <a href=".#" className="c_items">
            <img src={require("../../image/git.png")} alt="" />
          </a>

        </div>
      </div>
    </div>
  );
}
